import * as types from './constants';

// Update Lookbook Order
export const updateLookbookOrderRequest = data => (
  { type: types.UPDATE_LOOKBOOK_ORDER_REQUEST, payload: data }
);

export const updateLookbookOrderDone = data => (
  { type: types.UPDATE_LOOKBOOK_ORDER_DONE, payload: data }
);

export const updateLookbookOrderFailed = errors => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FAILED, payload: errors }
);

export const updateLookbookOrderClearErrors = prop => (
  { type: types.UPDATE_LOOKBOOK_ORDER_CLEAR_ERRORS, payload: prop }
);

export const updateLookbookOrderReset = () => (
  { type: types.UPDATE_LOOKBOOK_ORDER_RESET }
);